export const scrollPageCache = new Map<string, number>();
export const collapsibleOpenCache = new Map<string, boolean>();

let resetVersion = 0;
const listeners = new Set<() => void>();

/**
 * External store used by `PlayerSummaryCard` to reset its per-card UI state
 * (collapsible open + horizontal scroll offset) whenever the underlying list
 * query result changes (search, filter, sort, pagination).
 */
export const summaryResetStore = {
  subscribe(callback: () => void) {
    listeners.add(callback);
    return () => {
      listeners.delete(callback);
    };
  },
  getSnapshot() {
    return resetVersion;
  },
  reset() {
    scrollPageCache.clear();
    collapsibleOpenCache.clear();
    resetVersion += 1;
    listeners.forEach(listener => listener());
  },
};
